import {OnInit} from '@angular/core';
import {PromocionesService} from "../../core/promociones/promociones.service";
import {MessageService} from "primeng/components/common/messageservice";
import {FormGroup, Validators} from "@angular/forms";
import * as _ from 'lodash';
import {GamePromotion} from "../../core/promociones/game-promotion";

declare var $;

export abstract class Promociones implements OnInit {

  NO_CODE_TYPE = -1;
  REGISTRO_TYPE = 0;
  CODES_TYPE = 1;
  ORGANIC_CODES_TYPE = 2;
  EVENTS_TRIGGER_TYPE = 3;
  UNIC_CODES = 4;
  PROMOTBYRECHARGE = 'SaldoPorRecarga';

  isGanalottodo: boolean;
  promotionTypeList: any[] = [];
  promotionForm: FormGroup;
  isReadOnly: false;
  isLoading: Boolean = false;
  imageDefault: string = "/assets/imgs/thumbnail.svg";
  promotion: any = {principal: true, isByCode: 0, codeType: this.NO_CODE_TYPE, promotionTriggers: []};
  public promotionList: any[] = [];
  promotionKey;
  promotionActive = true;
  newPromotion = false;
  codesToAdd: string[] = [];
  codesToRemove: any = [];
  gamesToPromotion: GamePromotion[];
  gamesOfPromotion: any[] = [];
  gamesToAddInPromotion: any[] = [];
  gamesToDeleteInPromotion: any[] = [];
  //codePromotionFlag;// = false;
  codeTypeTmp = this.REGISTRO_TYPE;
  organicCodes = [];
  promotionTriggers = [];
  promotionTriggersToSave = [];
  showInputAmountForCharge = false;

  constructor(public promocionesService: PromocionesService,
              public messageService: MessageService,) {

  }

  ngOnInit() {
  }

  getTypePromotions() {
    this.promocionesService.getPromotionTypeList(this.isGanalottodo)
      .subscribe(
        success => {
          console.log('Se muestra informacion del listado:', success);
          if (this.newPromotion) {
            this.promotionTypeList = success;
          }
        },
        error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        }
      );
  }

  getPromotionTriggers() {
    this.promocionesService.getPromotionTriggers().subscribe((promotionTriggers) => {
      promotionTriggers.forEach((t) => {
        t.checked = this.promotion.promotionTriggers && this.promotion.promotionTriggers.find((el) => {
          return el.id == t.id;
        });
        this.promotionTriggers.push(t);
        if (t.checked) {
          this.promotionTriggersToSave.push(t.id);
        }
      });
    });
  }

  protected uploadFile(event: any, template: string, image: string) {
    this.messageService.clear();
    var allowedExtensions = /(.jpg|.jpeg|.png|.svg)$/i;
    if (!allowedExtensions.exec(event.target.files[0].name)) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Solo es posible cargar archivos con las extensiones: .jpeg/.jpg/.png/.svg'
      });
      //fileInput.value = '';
      return false;
    } else if ((event.target.files[0].size / 1024) < 1024) {
      let img = new Image();
      img.onload = () => {
        console.log(' ancho (width) = ' + img.width + ' , altura (height) = ' + img.height);
        let fileId = _.find(DIMENSION, item => {
          return item.component == event.target.id;
        });
        if (this.promotionList.length > 0) {
          _.remove(this.promotionList, element => {
            return element.templateName == template && element.imagePosition == image;
          });
        }
        if ((fileId.width == null || fileId.width == img.width) && (fileId.height == null || fileId.height == img.height)) {
          this.promotionList.push(
            {
              "templateName": template,
              "imageName": image + '.' + event.target.files[0].name.split('.')[1],
              "imagePosition": image,
              "resources": event.target.files[0]
            }
          );
          this.setPreviewImage(event);
        } else {
          this.promotionForm.get(event.target.id).setValue('');

          let img: any = document.getElementById('up' + event.srcElement.id);
          img.src = this.imageDefault;

          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: '',
            detail: 'La imagen debe medir: ' + fileId.width + 'px (ancho) x ' + fileId.height + 'px (alto)'
          });
        }

      };
      img.src = URL.createObjectURL(event.target.files[0]);


    } else {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: 'La imagen debe pesar menos de 1 MB'
      });
    }
  }

  protected updatePromotion() {
    if (this.promotionForm.valid) {
      let formData = this.fillModel();
      this.isLoading = true;
      this.promocionesService.patchPromotion(formData, this.promotionKey)
        .finally(() => this.isLoading = false)
        .subscribe(
          success => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'success',
              summary: '',
              detail: 'La promoción se actualizo exitosamente.'
            });
            this.goBack(this.promotionForm.value.promotionType);
          },
          error => {
            console.log('Error: ', error);
            let message = 'ocurrio un problema al actualizar, intentalo nuevamente';
            if (error.status === 400) {
              message = error.detail;
            }
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: '',
              detail: message
            });
          });
    } else {
      console.log(this.promotionForm);
    }
  }


  protected retrievePromotion(key) {
    this.isLoading = true;
    this.promocionesService.getPromotionByKey(key)
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(
        success => {
          this.promotion = success;
          this.organicCodes = success.organicCodes;
          this.codeTypeTmp = this.promotion.codeType;
          this.gamesOfPromotion = this.promotion.promotionGames;
          console.log('this.promotion.promotionType', this.promotion.typePromotion);
          this.promotionTypeList.push(this.promotion.typePromotion);
          this.fillGamesToPromotion(this.promotion.promotionGames);
          setTimeout(() => this.initForm(success));
          this.updateValidationsForm();
          console.log('mostramos la promocion: ', success);
          this.getPromotionTriggers();
          this.showInputAmountForCharge = !!success.accumulatedBalanceForPromotion;
        },
        error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        });
  }

  fillGamesToPromotion(promotionGames) {
    if (promotionGames) {
      promotionGames.forEach(promotionGame => {
        this.gamesToPromotion.find(x => x.gameId === promotionGame.gameId).isSelected = true;
      });
    }
  }

  protected getResource(promotionData, template: string, position: string, fileId: string): string {
    let url = '';
    if (promotionData) {
      let resource = _.find(promotionData.resourcesBeans, resource => {
        return resource.template == template && resource.position == position;
      });
      url = resource != undefined ? resource.urlResource : '';
      console.log('se tiene promo principal: ', resource);

      if (/(\.svg)$/i.test(url)) {
        console.log('imagen svg');
        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.send();
        ajax.onload = function (e) {
          console.log('svg', ajax.responseText);
          $('#up' + fileId).attr('src', 'data:image/svg+xml;utf8,' + ajax.responseText);
        };

      } else {
        $('#up' + fileId).attr('src', url == '' ? this.imageDefault : url);
      }
      $('#' + fileId).prop('type', 'url');

    }
    return url;
  }

  onSubmit() {
    console.log(this.promotionForm);
    if (this.promotionForm.value.promotionType === 'game') {
      this.promotionForm.patchValue({
        promotionAmount: 0
      });
    }
    if (this.promotionForm.valid) {
      let formData = this.fillModel();
      console.log('Mostramos el formData', formData);
      this.isLoading = true;
      this.promocionesService.savePromotion(formData)
        .finally(() => this.isLoading = false)
        .subscribe(response => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'success',
              summary: '',
              detail: 'La promoción se guardo exitosamente.'
            });
            const promotionType = this.promotionForm.value.promotionType;
            console.log('promotionType despues de guardar', promotionType);
            formData = new FormData();
            this.goBack(promotionType);
          },
          error => {
            this.messageService.clear();
            console.log('error: ', error);
            if (error === 'CodesAlreadyExist') {
              this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Se guardo la promoción sin códigos. Se encuentran repetidos'
              });
              formData = new FormData();
              this.goBack('saldo');
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error
              });
            }
          });
    } else {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Es necesario llenar todos los campos'
      });
    }
  }

  protected activePromotion() {
    this.promotionActive = this.promotionActive ? false : true;
  }

  protected codePromotion(codeType) {
    if (!this.newPromotion) {
      this.initForm(null);
      this.codeTypeTmp = codeType;
      this.isLoading = true;
      this.promocionesService.getPromotionByKey(this.promotionKey)
        .finally(() => {
          this.isLoading = false;
        })
        .subscribe(
          success => {
            this.promotion = success;
            this.promotion.codeType = this.codeTypeTmp;
            this.updateValidationsForm();
            setTimeout(() => this.initForm(success));
          });
    } else {
      this.codeTypeTmp = codeType;
      this.promotion.codeType = this.codeTypeTmp;
      this.updateValidationsForm();
    }

  }

  protected addGameToPromotion(game) {
    if (!this.gamesOfPromotion.find(gameToFind => gameToFind.gameId === game.gameId)) {
      if (this.gamesToAddInPromotion.indexOf(game.gameId) !== -1) {
        this.gamesToAddInPromotion.splice(this.gamesToAddInPromotion.indexOf(game.gameId), 1);
      } else {
        this.gamesToAddInPromotion.push(game.gameId);
      }
    }
    if (this.gamesOfPromotion.find(gameToFind => gameToFind.gameId === game.gameId) && game.isSelected) {
      this.gamesToDeleteInPromotion.push(game.gameId);
    }
    if (this.gamesOfPromotion.find(gameToFind => gameToFind.gameId === game.gameId) && !game.isSelected) {
      this.gamesToDeleteInPromotion.splice(this.gamesToDeleteInPromotion.indexOf(game), 1);
    }
    console.log('gamesToAddInPromotion', this.gamesToAddInPromotion);
    console.log('gamesToDeleteInPromotion', this.gamesToDeleteInPromotion);
    game.isSelected = !game.isSelected;
  }


  abstract setPreviewImage(principalEvent);

  abstract fillModel(): FormData;

  abstract goBack(promotionType): void;

  abstract initForm(values);


  updateValidationsForm() {
    if (this.promotion.codeType === this.ORGANIC_CODES_TYPE || this.promotion.codeType === this.EVENTS_TRIGGER_TYPE || this.promotion.codeType === this.UNIC_CODES) {
      console.log('Se agrega validación a campo de accumulatedBalanceForPromotion');
      this.promotionForm.get('file4').clearValidators();
      this.promotionForm.get('file4').updateValueAndValidity();
      // this.promotionForm.get('accumulatedBalanceForPromotion').setValidators([Validators.required]);
      // this.promotionForm.get('accumulatedBalanceForPromotion').updateValueAndValidity();
      this.promotionForm.updateValueAndValidity();
      this.promotion.principal = false;
    } else {
      console.log('No se agrega validación a campo de accumulatedBalanceForPromotion');
      this.promotionForm.get('file4').setValidators([Validators.required]);
      this.promotionForm.get('file4').updateValueAndValidity();
      this.promotionForm.get('accumulatedBalanceForPromotion').clearValidators();
      this.promotionForm.get('accumulatedBalanceForPromotion').updateValueAndValidity();
      this.promotionForm.updateValueAndValidity();
    }
  }

}

export const DIMENSION = {
  file1: {
    component: 'file1',
    name: 'forward_first',
    width: 426,
    height: 409,
    imageInfo: '/assets/imgs/promotions/forwardP.jpg'
  },
  file2: {
    component: 'file2',
    name: 'forward_secondary',
    width: 346,
    height: 367,
    imageInfo: '/assets/imgs/promotions/forwardS.jpg'
  },
  file3: {
    component: 'file3',
    name: 'forward_back',
    width: 758,
    height: 636,
    imageInfo: '/assets/imgs/promotions/forwardB.jpg'
  },

  file4: {component: 'file4', name: 'checkEmail_first', imageInfo: '/assets/imgs/promotions/checkEmailP.jpg'}, //width: 426, height: 409,
  file5: {component: 'file5', name: 'checkEmail_footer', imageInfo: '/assets/imgs/promotions/checkEmailF.jpg'}, //width: 734, height: 85,

  //file6: { name:'checked_first', width: 345, height: 281 },
  file6: {
    component: 'file6',
    name: 'checked_first',
    width: 346,
    height: 367,
    imageInfo: '/assets/imgs/promotions/checkedP.jpg'
  },
  file7: {
    component: 'file7',
    name: 'checked_back',
    width: 1001,
    height: 1215,
    imageInfo: '/assets/imgs/promotions/checkedB.jpg'
  },

  file8: {
    component: 'file8',
    name: 'downloadEmail_first',
    width: 346,
    height: 367,
    imageInfo: '/assets/imgs/promotions/downloadEmailP.jpg'
  },
  file9: {
    component: 'file9',
    name: 'downloadEmail_back',
    width: 758,
    height: 636,
    imageInfo: '/assets/imgs/promotions/downloadEmailB.jpg'
  },

  file10: {
    component: 'file10',
    name: 'landing_first',
    width: 426,
    height: 409,
    imageInfo: '/assets/imgs/promotions/landingP.jpg'
  },
  file11: {
    component: 'file11',
    name: 'landing_secondary',
    width: 346,
    height: 367,
    imageInfo: '/assets/imgs/promotions/landingS.jpg'
  },
  file12: {
    component: 'file12',
    name: 'landing_back',
    width: 3411,
    height: 595,
    imageInfo: '/assets/imgs/promotions/landingB.jpg'
  },


  file13: {
    component: 'file13',
    name: 'gratification_first',
    width: 426,
    height: 409,
    imageInfo: '/assets/imgs/promotions/Modal.jpg'
  },
};



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/promociones.ts